import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NoOpEncoder_getInstanceajja35qtb1df as NoOpEncoder_getInstance } from '../internal/NoOpEncoder.mjs';
import {
  encodeNotNullMark352dnk5r97tvq as encodeNotNullMark,
  beginCollection27i47rk9upjw4 as beginCollection,
  encodeSerializableValue1mu7jsn2oheqi as encodeSerializableValue,
  encodeNullableSerializableValue22qo2euy9x1r4 as encodeNullableSerializableValue,
  shouldEncodeElementDefault1vy568gzcy4z0 as shouldEncodeElementDefault,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
} from './Encoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractEncoderClass;
function AbstractEncoder() {
  if (AbstractEncoderClass === VOID) {
    class $ {
      static new_kotlinx_serialization_encoding_AbstractEncoder_5rmec_k$() {
        return createThis(this);
      }
      beginStructure_yljocp_k$(descriptor) {
        return this;
      }
      endStructure_1xqz0n_k$(descriptor) {
      }
      encodeElement_5v7eyb_k$(descriptor, index) {
        return true;
      }
      encodeValue_g68i1f_k$(value) {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
      }
      encodeNull_ejiosz_k$() {
        throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$("'null' is not supported by default");
      }
      encodeBoolean_tu2e59_k$(value) {
        return this.encodeValue_g68i1f_k$(value);
      }
      encodeByte_6txfee_k$(value) {
        return this.encodeValue_g68i1f_k$(value);
      }
      encodeShort_gza6si_k$(value) {
        return this.encodeValue_g68i1f_k$(value);
      }
      encodeInt_y5zi3z_k$(value) {
        return this.encodeValue_g68i1f_k$(value);
      }
      encodeLong_vlw3uq_k$(value) {
        return this.encodeValue_g68i1f_k$(value);
      }
      encodeFloat_b8b85a_k$(value) {
        return this.encodeValue_g68i1f_k$(value);
      }
      encodeDouble_n270q9_k$(value) {
        return this.encodeValue_g68i1f_k$(value);
      }
      encodeChar_id8ngf_k$(value) {
        return this.encodeValue_g68i1f_k$(new (Char())(value));
      }
      encodeString_424b5v_k$(value) {
        return this.encodeValue_g68i1f_k$(value);
      }
      encodeEnum_2qin0y_k$(enumDescriptor, index) {
        return this.encodeValue_g68i1f_k$(index);
      }
      encodeInline_wxp5pu_k$(descriptor) {
        return this;
      }
      encodeBooleanElement_ydht7q_k$(descriptor, index, value) {
        if (this.encodeElement_5v7eyb_k$(descriptor, index)) {
          this.encodeBoolean_tu2e59_k$(value);
        }
      }
      encodeByteElement_kft2ib_k$(descriptor, index, value) {
        if (this.encodeElement_5v7eyb_k$(descriptor, index)) {
          this.encodeByte_6txfee_k$(value);
        }
      }
      encodeShortElement_4bcdph_k$(descriptor, index, value) {
        if (this.encodeElement_5v7eyb_k$(descriptor, index)) {
          this.encodeShort_gza6si_k$(value);
        }
      }
      encodeIntElement_krhhce_k$(descriptor, index, value) {
        if (this.encodeElement_5v7eyb_k$(descriptor, index)) {
          this.encodeInt_y5zi3z_k$(value);
        }
      }
      encodeLongElement_ovnxxh_k$(descriptor, index, value) {
        if (this.encodeElement_5v7eyb_k$(descriptor, index)) {
          this.encodeLong_vlw3uq_k$(value);
        }
      }
      encodeFloatElement_oe8hn_k$(descriptor, index, value) {
        if (this.encodeElement_5v7eyb_k$(descriptor, index)) {
          this.encodeFloat_b8b85a_k$(value);
        }
      }
      encodeDoubleElement_a6rqhe_k$(descriptor, index, value) {
        if (this.encodeElement_5v7eyb_k$(descriptor, index)) {
          this.encodeDouble_n270q9_k$(value);
        }
      }
      encodeCharElement_5nnekk_k$(descriptor, index, value) {
        if (this.encodeElement_5v7eyb_k$(descriptor, index)) {
          this.encodeChar_id8ngf_k$(value);
        }
      }
      encodeStringElement_1n5wu2_k$(descriptor, index, value) {
        if (this.encodeElement_5v7eyb_k$(descriptor, index)) {
          this.encodeString_424b5v_k$(value);
        }
      }
      encodeInlineElement_69jjkk_k$(descriptor, index) {
        return this.encodeElement_5v7eyb_k$(descriptor, index) ? this.encodeInline_wxp5pu_k$(descriptor.getElementDescriptor_ncda77_k$(index)) : NoOpEncoder_getInstance();
      }
      encodeSerializableElement_isqxcl_k$(descriptor, index, serializer, value) {
        if (this.encodeElement_5v7eyb_k$(descriptor, index)) {
          this.encodeSerializableValue_3uuzip_k$(serializer, value);
        }
      }
      encodeNullableSerializableElement_5lquiv_k$(descriptor, index, serializer, value) {
        if (this.encodeElement_5v7eyb_k$(descriptor, index)) {
          this.encodeNullableSerializableValue_ibrab1_k$(serializer, value);
        }
      }
    }
    protoOf($).encodeNotNullMark_415a1t_k$ = encodeNotNullMark;
    protoOf($).beginCollection_9edss2_k$ = beginCollection;
    protoOf($).encodeSerializableValue_3uuzip_k$ = encodeSerializableValue;
    protoOf($).encodeNullableSerializableValue_ibrab1_k$ = encodeNullableSerializableValue;
    protoOf($).shouldEncodeElementDefault_x8eyid_k$ = shouldEncodeElementDefault;
    initMetadataForClass($, 'AbstractEncoder', VOID, VOID, [Encoder(), CompositeEncoder()]);
    AbstractEncoderClass = $;
  }
  return AbstractEncoderClass;
}
//region block: exports
export {
  AbstractEncoder as AbstractEncoder2gxtu3xmy3f8j,
};
//endregion

//# sourceMappingURL=AbstractEncoder.mjs.map
